import type { PropRenderItem } from 'uikit';
import { Checkbox, SelectItem } from 'uikit';

import type React from 'react';

import type { IMultiselectItem } from './Multiselect';
import { MultiselectInformer } from './MultiselectInformer';

import Styles from './MultiselectItem.module.css';

const informerStyle = { marginRight: 10 };

export const MultiselectItem: PropRenderItem<IMultiselectItem> = (props) => {
    const { item, active, hovered, onClick, onMouseEnter } = props;

    return (
        <SelectItem
            label={
                (
                    <div className={Styles.multiselectItem}>
                        <Checkbox disabled={item?.disabled} checked={active} />
                        {item.informer ? (
                            <MultiselectInformer
                                value={item.informer.value}
                                style={informerStyle}
                                className={item.informer.className}
                                message={item.informer.message}
                            />
                        ) : undefined}{' '}
                        <div>{item?.label}</div>
                    </div>
                ) as any
            }
            active={active}
            hovered={hovered}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            size="xs"
            indent="normal"
            disabled={false}
            multiple={false}
        />
    );
};

// @ts-ignore
MultiselectItem.displayName = 'MultiselectItem';
